export const profileConstants = {
    ...getConstantObj()
};

function getConstantObj() {
    let obj = {
        getUserProfile_request: "getUserProfile_request",
        getUserProfile_success: "getUserProfile_success",
        getUserProfile_failure: "getUserProfile_failure",
    }

    let obj_formatted = {};
    let domain = "billingPortal.profile/";
    for (let property in obj) {
        if (obj.hasOwnProperty(property)) {
            obj_formatted[property] = domain + obj[property];
        }
    }

    return obj_formatted;
}